import React from 'react';
import {c_zones, c_modes} from '../a-Graphic/Colors';

import getMyMap, {createNamesLayer, createCommunesLayer} from '../b-LeafletMap/leaflet_map';

import PlotPie from '../c-PlotlyFigures/PlotPie'


class ZonesItemExchange extends React.Component {

    render(){
      var territory = this.props.territory;

      function label_text_2(status){
        var total = Object.values(status).reduce((a,b) => a + b, 0);
        var text = Object.fromEntries(
                    Object.entries(status).map(
                      ([k, v], i) => [k, "<span style='font-size: 15px;'>" + Math.round(v/total*1000)/10 +"%</span>" ]
                    )
                  );
        return(Object.values(text))
      }

      function colors(status){
        return Object.keys(status).map((m)=> c_modes[m])
      }
      function hover_text_2(status, label){
        var total = Object.values(status).reduce((a,b) => a + b, 0);
        var text = Object.fromEntries(
                    Object.entries(status).map(
                      ([k, v], i) => [k, k + "</br></br><span style='font-weight: 300;'>" + Math.round(v/total*1000)/10 +"%</span>"]
                    )
                  );
        return(Object.values(text))
      }
      function filter_domicile(data){
        return Object.assign({}, ...Object.entries(data).filter(([k,v]) => k != "domicile").map(([k,v]) => ({[k]:v})));
      }

      function compute_prop(values, concerned_value, unit){
        return Math.round(values[concerned_value]/territory.all_travels.total[unit]*1000)/10
      }

      var zm = this.props.territory.all_travels.zones_means;
      var zmg = this.props.territory.all_travels.zones_means_global;
      var zones = Object.keys(zm);
      var zones_nb = Math.max(...zones.map((z)=>parseFloat(z)));

      var id_from = this.props.zone_from < this.props.zone_to ? this.props.zone_from : this.props.zone_to
      var id_to = this.props.zone_from > this.props.zone_to ? this.props.zone_from : this.props.zone_to

      var name_from = this.props.zone_from > 0 ? "zone " + this.props.zone_from : "extérieur"
      var name_to = this.props.zone_to > 0 ? "zone " + this.props.zone_to : "extérieur"

      var color_from = this.props.zone_from > 0 ? this.props.zone_from : 0
      var color_to = this.props.zone_to > 0 ? this.props.zone_to : 0

      var c_zones_t = c_zones.map((c)=>c+"bf")

      return(
        <div className="row mb-4 pl-1 pr-1">
          <div className="col-12">
            <div className="row mb-1 justify-content-center align-items-end">
                <div className="col-auto">
                    <PlotPie values={Object.values(zm[id_from][id_to][this.props.unit])}
                             labels={label_text_2(zm[id_from][id_to][this.props.unit])}
                             text={hover_text_2(zm[id_from][id_to][this.props.unit], this.props.label)}
                             colors={colors(zm[id_from][id_to][this.props.unit])}
                             id={"zones_means_" + id_from + id_to }
                             textposition="inside"
                             height="120"
                             width="120"/>
                </div>
                <div className="col-auto pl-0">
                  <p style={{fontSize: "1.5vw", fontWeight: "600"}}>{compute_prop(zmg[this.props.unit],"zones_"+id_from+"_"+id_to, this.props.unit)}%</p>
                  <p>{zmg[this.props.unit]["zones_"+id_from+"_"+id_to] != undefined ?
                      zmg[this.props.unit]["zones_"+id_from+"_"+id_to].toLocaleString("fr-FR") :
                      0} {this.props.label}</p>
                </div>
            </div>
            <div className="row align-items-center">
                <div className="col-auto p-1 pl-2 pr-2" style={{backgroundColor: c_zones_t[color_from], borderRadius:"3px"}}>
                  <h4>{name_from}</h4>
                </div>
                <div className="col line-arrow">
                </div>
                <div className="col-auto p-1 pl-2 pr-2" style={{backgroundColor: c_zones_t[color_to], borderRadius:"3px"}}>
                  <h4>{name_to}</h4>
                </div>
            </div>
          </div>
        </div>
    );
  }
}

export default ZonesItemExchange;
